// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"9bf65fdc","257":"ff443779","787":"63a3d4ac"}[chunkId] + ".chunk.js";
};